import React, { useContext, useEffect } from "react";
import config from "../../config";
import { decryptFileAES, decryptText } from "../../Utils/OstreonEncryption";
import { useState } from "react";
import styles from "./styles/Home.module.css";
import FileIcon from "../User/File/file";
import Assets from "./Assets";
import { useNavigate } from "react-router-dom";
import Loading from "../Loading/Loading";
import { decryptFiles, decryptLegal } from "../../Utils/dataEncryption";
import Info from "../User/Info/info";
import { LanguageContext } from "../../Context/changeLanguageProvider";
import BenefNotaryCard from "./benefNotaryCard";
import BenefTrusteeCard from "./benefTrusteeCard";
import { decryptBase64file } from "../../Utils/UploadFile";

const aes_pattern = /^[0-9a-fA-F]{16}-[0-9a-fA-F]{24}-[0-9a-fA-F]+$/;
const base_url = config.base_url;
const decryptAssetFiles = async (private_key, assetFiles) => {
  const new_assetFiles = await Promise.all(
    assetFiles.map(async (e) => {
      var newFile = {
        id: e.id,
        name: "",
        lastModified: "",
        size: "",
      };
      newFile.name = await decryptText(private_key, e.name);
      newFile.size = await decryptText(private_key, e.size);
      newFile.lastModified = await decryptText(private_key, e.lastModified);
      return newFile;
    })
  );
  return new_assetFiles;
};
const decryptAsset = async (e, private_key) => {
  return new Promise(async (resolve, reject) => {
    try {
      var new_asset = {
        asset_id: e.asset_id,
        asset_files: "",
        asset_name: "",
        asset_type: "",
        credentials: "",
        description: "",
        trustees: e.trustees,
      };
      console.log(e);
      // new_asset.asset_files =JSON.parse(await decryptText(private_key, e.asset_files, "asset_files")) ;
      let decrypted_asset_files;
      if (e.asset_files.includes("[")) {
        decrypted_asset_files = await decryptAssetFiles(
          private_key,
          JSON.parse(e.asset_files)
        );
      } else {
        decrypted_asset_files = JSON.parse(
          await decryptText(private_key, e.asset_files, "asset_files")
        );
      }
      // new_asset.asset_files =JSON.parse(await decryptText(private_key, e.asset_files, "asset_files")) ;
      // const decrypted_asset_files = await decryptAssetFiles(privateKEY, JSON.parse(e.asset_files))
      new_asset.asset_files = decrypted_asset_files;
      new_asset.asset_name = JSON.parse(
        await decryptText(private_key, e.asset_name, "asset_name")
      );
      new_asset.asset_type = JSON.parse(
        await decryptText(private_key, e.asset_type, "asset_type")
      );
      new_asset.credentials = JSON.parse(
        await decryptText(private_key, e.credentials, "credentials")
      );
      new_asset.description = JSON.parse(
        await decryptText(private_key, e.description, "description")
      );
      new_asset.trustees = aes_pattern.test(e.trustees)
        ? JSON.parse(await decryptText(private_key, e.trustees, "trustees"))
        : JSON.parse(e.trustees);
      resolve(new_asset);
    } catch (error) {
      console.log(error);
      reject();
    }
  });
};
const decryptBeneficiary = async (e, private_key) => {
  return new Promise(async (resolve, reject) => {
    try {
      var new_beneficiary = { ...e, personal_documents: null };

      // new_beneficiary.personal_documents =JSON.parse(await decryptText(private_key, e.personal_documents))
      new_beneficiary.personal_documents = await decryptFiles(
        private_key,
        JSON.parse(e.personal_documents)
      );
      new_beneficiary.message = JSON.parse(
        await decryptText(private_key, e.message)
      );
      resolve(new_beneficiary);
    } catch (error) {
      console.log(error);
      reject(new_beneficiary);
    }
  });
};
const decryptTrustee = (e, private_key) => {
  return new Promise(async (resolve, reject) => {
    try {
      let new_trustee = {
        user_id: e.user_id,
        name: "",
        email: "",
        phone_number: "",
        additional_information: "",
        profile_avatar: null,
      };
      new_trustee.name = JSON.parse(await decryptText(private_key, e.name));
      new_trustee.email = JSON.parse(await decryptText(private_key, e.email));
      new_trustee.additional_information = JSON.parse(
        await decryptText(private_key, e.additional_information)
      );
      new_trustee.phone_number = JSON.parse(
        await decryptText(private_key, e.phone_number)
      );
      new_trustee.awareness_status = JSON.parse(
        await decryptText(private_key, e.awareness_status)
      );
      if (e?.profile_avatar) {
        const avatar_extension = e?.profile_avatar[0];
        if (avatar_extension == "/") {
          new_trustee.profile_avatar = e?.profile_avatar;
        } else if (avatar_extension == "i") {
          try {
            new_trustee.profile_avatar = await decryptBase64file(
              private_key,
              e?.profile_avatar
            );
          } catch (error) {
            new_trustee.profile_avatar = e?.profile_avatar;
          }
        } else {
          new_trustee.profile_avatar = await decryptBase64file(
            private_key,
            e?.profile_avatar
          );
        }
      }
      resolve(new_trustee);
    } catch (error) {
      reject(error);
    }
  });
};
export const downloadFile = async (
  file_id,
  filename,
  private_key,
  Progress = () => {}
) => {
  console.log("Downloading...");
  console.log(file_id);
  console.log(filename);
  Progress(`Downloading ${filename}...`);
  return new Promise((resolve, reject) => {
    fetch(base_url + "beneficiary/download/file", {
      method: "POST",
      mode: "cors",
      credentials: "include",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: `file_id=${file_id}`,
    })
      .then((res) => {
        if (res.status !== 200) {
          throw new Error(res.status);
        } else {
          console.log("file_downloaded");
          return res.blob();
        }
      })
      .then(async (blob) => {
        Progress(`Decrypting ${filename}...`);
        console.log("ha llegado");
        const encrypted_file = new File([blob], filename);
        console.log("es blob");
        const decrypted_file = await decryptFileAES(
          private_key,
          encrypted_file
        );
        const url = URL.createObjectURL(decrypted_file);
        resolve();
        const link = document.createElement("a");
        link.href = url;
        link.download = decrypted_file.name;
        document.body.appendChild(link);
        link.click();
      })
      .catch((e) => {
        reject(e);
      });
  });
};

function Home() {
  const navigate = useNavigate();
  const [modal, setModal] = useState(undefined);
  const private_key = window.sessionStorage.getItem("ostreon_key");
  const data = null;
  const [assets_, setAssets] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [beneficiary_, setBeneficiary] = useState(null);
  const [trustees_, setTrustees] = useState(null);
  const [legal_, setLegal] = useState(null);
  const [customer_name, setCustomerName] = useState();
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [content, setContent] = useState(
    websiteCurrentLang.content.Beneficiary.Home
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.Beneficiary.Home);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    fetch(base_url + "beneficiary/data", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
    })
      .then((res) => {
        if (res.status !== 200) return navigate("/beneficiary/login");
        else return res.json();
      })
      .then(async (data) => {
        console.log(data);
        const { assets, beneficiary, trustees, legal, customer_name } = data;
        setCustomerName(customer_name);
        const new_assets = await Promise.all(
          assets.map((asset) => {
            return decryptAsset(asset, private_key);
          })
        );
        setAssets(new_assets);
        const new_beneficiaries = await decryptBeneficiary(
          beneficiary,
          private_key
        );
        setBeneficiary(new_beneficiaries);
        const new_trustees = await Promise.all(
          trustees.map((trustee) => {
            return decryptTrustee(trustee, private_key);
          })
        );
        setTrustees(new_trustees);
        const new_legal = await Promise.all(
          legal?.map((e) => {
            return decryptLegal(e, private_key);
          })
        );
        setLegal(new_legal);
        setLoaded(true);
      })
      .catch((e) => console.log(e));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    console.log(assets_);
    console.log(beneficiary_);
    console.log(trustees_);
    console.log(legal_);
  }, [assets_, beneficiary_, legal_, trustees_]);
  return loaded ? (
    <div className={styles.main}>
      <div className={styles.title}>{content.homeTitle1}</div>
      <div className={styles.personal_box}>
        <div className={styles.subtitle}>
          {dublicatedcontent?.personal_message_from?.replace(
            "customer_name",
            customer_name
          )}
        </div>
        <div className={styles.description}>
          {beneficiary_?.message ? beneficiary_.message : null}
        </div>
        <div className={styles.files_row}>
          {beneficiary_
            ? beneficiary_?.personal_documents?.map((file) => {
                return (
                  <FileIcon
                    deleteable={false}
                    key={file.id}
                    filename={file.name}
                    date={file.lastModified}
                    size={file.size}
                    OnClick={() =>
                      downloadFile(file.id, file.name, private_key)
                    }
                  ></FileIcon>
                );
              })
            : null}
        </div>
      </div>
      {legal_?.length > 0 && (
        <section className={styles.section}>
          <div
            className={styles.section_title}
            style={{
              display: "block",
            }}
          >
            <span>{dublicatedcontent?.lawyer_notary_wealth_manager}</span>
            <p className={styles.subtitleText}>
              {
                dublicatedcontent.The_notary_was_provided_with_your_contact_details
              }
            </p>
          </div>
          {legal_.map((notary) => {
            return (
              <BenefNotaryCard
                setModal={setModal}
                key={notary.name}
                notary={notary}
              />
            );
          })}
        </section>
      )}
      {beneficiary_.trustees.length > 0 && (
        <section className={styles.section}>
          <div className={styles.section_title}>
            <span>{dublicatedcontent.dublicatedText64}</span>
            <Info message={dublicatedcontent.dublicatedText64}></Info>
          </div>
          <div
            className={styles.trustee_container}
            style={{
              justifyContent:
                beneficiary_.trustees.length === 2
                  ? "space-around"
                  : "space-between",
            }}
          >
            {beneficiary_.trustees.map((trustee_id) => {
              return trustees_.map((trustee) => {
                if (trustee.user_id === trustee_id) {
                  return (
                    <BenefTrusteeCard
                      assets={assets_}
                      setModal={setModal}
                      trustee={trustee}
                    />
                  );
                } else return "";
              });
            })}
          </div>
        </section>
      )}
      {
        <div className={styles.assets_section}>
          <div className={styles.asset_box}>
            <div className={styles.title}>{content.homeTextTitle2}</div>
            <Assets data={assets_} trustees={trustees_} />
          </div>
        </div>
      }
      {modal && <div style={{ zIndex: 6 }}>{modal}</div>}
    </div>
  ) : (
    <div style={{ position: "relative", zIndex: "3" }}>
      <Loading text={content.homeTextText5} />
    </div>
  );
}

export default Home;
